//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        label: String,
        labelRight: String,
        flat: Boolean,
        noColor: Boolean,
        download: Boolean,
        gutter: {
            type: String,
            default: 'md',
        },
    },
};
